export enum TimesheetErrorType {
  ClosingError = "CLOSING_ERROR",
  UserError = "USER_ERROR",
  ProcessingError = "PROCESSING_ERROR"
}
